import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	position: relative;

	.actions-area {
		display: flex;
		gap: 20px;

		.add_area {
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			padding: 15px;
			border: 2px solid var(--main-green);
			border-radius: 10px;
			height: 300px;

			.input-area {
				display: flex;
				flex-direction: column;
				gap: 5px;

				label {
					font-size: 14px;
				}
				input {
					padding: 5px 10px;
					border-radius: 8px;
					border: 2px solid var(--light-green);
					outline: none;
				}
			}
			button {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 10px;
				font-size: 18px;

				background-color: var(--main-blue);
				color: white;
				padding: 10px 20px;
				border-radius: 8px;
				transition: 400ms;

				svg {
					font-size: 20px;
				}
			}

			button:hover {
				background-color: var(--dark-blue);
			}

			.checkbox-area {
				flex-direction: row;
			}
		}
	}

	.close-add_area {
		display: none;
	}

	h1 {
		font-size: 32px;
		margin-bottom: 30px;
	}

	div > h2 {
		font-size: 20px;
	}
	.userlist > ul {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		min-height: 70vh;
		max-height: 70vh;

		padding: 15px;
		border-radius: 10px;
		border: 2px solid var(--main-green);
		width: max-content;

		.list {
			display: flex;
			flex-direction: column;
			gap: 10px;
			overflow-y: scroll;
			margin-bottom: 10px;
		}

		.button-wrapper button {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 10px;
			font-size: 18px;

			background-color: var(--main-blue);
			color: white;
			padding: 10px 20px;
			border-radius: 8px;
			transition: 400ms;

			svg {
				font-size: 20px;
			}
		}

		.button-wrapper button:hover {
			background-color: var(--dark-blue);
		}

		li {
			border-radius: 10px;
			width: 350px;
			padding: 5px 10px;
			border: 2px dashed black;
			display: flex;
			flex-direction: column;
			gap: 10px;

			button {
				background-color: #9e3650;
				padding: 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 5px;
				gap: 10px;

				transition: 400ms;
				color: white;

				svg {
					font-size: 18px;
				}
			}

			button:hover {
				background-color: rgb(223, 58, 99);
			}
		}
	}

	.addind-wrapper {
		display: flex;
		flex-direction: column;

		align-self: center;
		gap: 20px;

		ul {
			border: none;
			li {
				border: none;
				padding: 0;
				margin: 0;
			}
		}
	}

	.closeModal {
		display: none;
	}
`;

export const InfoModal = styled.div`
	position: absolute;
	display: flex;

	width: 100%;
	height: 100%;

	align-items: center;
	justify-content: center;

	ul {
		border-radius: 10px;
		background-color: #b8d6c9;
		padding: 20px;
		li {
			margin: 5px 0;
		}

		button {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 10px;
			padding: 10px 20px;
			background-color: #9e3650;
			border-radius: 8px;
			float: right;
			transition: 400ms;
			color: white;

			svg {
				font-size: 20px;
			}
		}
		button:hover {
			background-color: rgb(223, 58, 99);
		}
	}
`;
